<template>
  <div>
    <WeekPlanTabComponent :isPlanning='true'/>
  </div>
</template>

<script>
import WeekPlanTabComponent from './WeekPlanTabComponent'

export default {
  name: 'plan-tab',
  data: function () {
    return {
    }
  },
  components: {
    WeekPlanTabComponent
  },
  created () {
  },
  mounted () {

  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {

  }
}
</script>

<style lang="scss">

</style>
